import { z } from 'zod'

export const SUPPORT_MCP_PUBLIC_READ_CONTRACT_VERSION = '1.0.0' as const

const supportMcpToolSchema = z.object({
  name: z.string(),
  description: z.string(),
  inputSchema: z.object({
    type: z.literal('object'),
    properties: z.record(z.unknown()),
    required: z.array(z.string()).optional(),
  }).passthrough(),
}).passthrough()

export const supportMcpToolsResponseSchema = z.object({
  tools: z.array(supportMcpToolSchema),
}).passthrough()

export const supportMcpToolsChatgptResponseSchema = supportMcpToolsResponseSchema

export type SupportMcpToolsResponse = z.infer<typeof supportMcpToolsResponseSchema>
export type SupportMcpToolsChatgptResponse = z.infer<typeof supportMcpToolsChatgptResponseSchema>
